import {
  DARK_THEME_MEDIA_QUERY,
  DEFAULT_DARK_THEME,
  DEFAULT_LIGHT_THEME,
} from 'lib/next-themes/constants';

function isServer(): boolean {
  return typeof window === 'undefined';
}

export function getTheme(key: string, fallback?: string): string | undefined {
  if (isServer()) return undefined;
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch (e) {
    // Unsupported
    console.warn('Error reading theme from localStorage');
    return fallback;
  }
}

export function getSystemTheme(
  mediaQuery: MediaQueryList | MediaQueryListEvent = window.matchMedia(
    DARK_THEME_MEDIA_QUERY,
  ),
): string {
  const isDark = mediaQuery.matches;
  return isDark ? DEFAULT_DARK_THEME : DEFAULT_LIGHT_THEME;
}

const DISABLE_ANIMATIONS_TICK = 1;
export function disableAnimation(): VoidFunction {
  const css = document.createElement('style');
  css.appendChild(
    document.createTextNode(
      `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`,
    ),
  );
  document.head.appendChild(css);

  // Return a callback to enable animations again
  return (): void => {
    // Force restyle
    window.getComputedStyle(document.body);

    // Wait for next tick before removing
    setTimeout(() => {
      document.head.removeChild(css);
    }, DISABLE_ANIMATIONS_TICK);
  };
}
